var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "c-input", class: _vm.generatedClass },
    [
      _vm.label
        ? _c("label", { staticClass: "label", attrs: { for: _vm.id } }, [
            _c("span", [
              _vm._v("\n      " + _vm._s(_vm.label)),
              _vm.required
                ? _c("span", { staticClass: "required" }, [_vm._v("*")])
                : _vm._e()
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("transition", { attrs: { name: "c-input-feedback" } }, [
        _vm.feedbackShow && _vm.feedbackMessage
          ? _c("span", { staticClass: "feedback" }, [
              _vm._v("\n      " + _vm._s(_vm.feedbackMessage) + "\n    ")
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "inner" },
        [
          _vm.icon && _vm.type !== "color"
            ? _c("c-icon", {
                staticClass: "icon",
                attrs: { width: "20px", height: "20px", icon: _vm.icon }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.type === "color"
            ? _c("c-icon", {
                staticClass: "icon",
                attrs: {
                  width: "20px",
                  height: "20px",
                  icon: _vm.icon || "color-sampler"
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.textArea
            ? _c(
                "textarea",
                _vm._b(
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.internalValue,
                        expression: "internalValue"
                      }
                    ],
                    staticClass: "input",
                    attrs: {
                      id: _vm.id,
                      disabled: _vm.disabled,
                      required: _vm.required,
                      placeholder: _vm.placeholder,
                      autocomplete: "off"
                    },
                    domProps: { value: _vm.internalValue },
                    on: {
                      focus: function($event) {
                        _vm.active = true
                      },
                      blur: function($event) {
                        _vm.active = false
                      },
                      change: _vm.handleChange,
                      keyup: [
                        _vm.handleKeyup,
                        function($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          return _vm.handleEnter.apply(null, arguments)
                        },
                        function($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k($event.keyCode, "esc", 27, $event.key, [
                              "Esc",
                              "Escape"
                            ])
                          ) {
                            return null
                          }
                          return _vm.handleEsc.apply(null, arguments)
                        }
                      ],
                      input: [
                        function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.internalValue = $event.target.value
                        },
                        _vm.handleMaskInput
                      ]
                    }
                  },
                  "textarea",
                  _vm.$attrs,
                  false
                )
              )
            : _vm.type !== "file"
            ? _c("input", {
                directives: [
                  {
                    name: "mask",
                    rawName: "v-mask",
                    value: _vm.mask,
                    expression: "mask"
                  },
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.internalValue,
                    expression: "internalValue"
                  },
                  {
                    name: "money",
                    rawName: "v-money",
                    value: _vm.isMoney ? _vm.moneyMask : false,
                    expression: "isMoney ? moneyMask : false"
                  }
                ],
                ref: "input",
                staticClass: "input",
                class: { "-empty": !_vm.internalValue },
                attrs: {
                  id: _vm.id,
                  disabled: _vm.disabled,
                  required: _vm.required,
                  autofill: "new-password",
                  placeholder: _vm.placeholder,
                  autocomplete: "off"
                },
                domProps: { value: _vm.internalValue },
                on: {
                  focus: function($event) {
                    _vm.active = true
                  },
                  blur: function($event) {
                    _vm.active = false
                  },
                  change: _vm.handleChange,
                  keyup: [
                    _vm.handleKeyup,
                    function($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      ) {
                        return null
                      }
                      return _vm.handleEnter.apply(null, arguments)
                    },
                    function($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "esc", 27, $event.key, [
                          "Esc",
                          "Escape"
                        ])
                      ) {
                        return null
                      }
                      return _vm.handleEsc.apply(null, arguments)
                    }
                  ],
                  input: [
                    function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.internalValue = $event.target.value
                    },
                    _vm.handleMaskInput
                  ]
                }
              })
            : _c("div", { staticClass: "input" }, [
                _c("input", {
                  class: ["input-field", { "-disabled": _vm.disabled }],
                  attrs: {
                    id: _vm.id,
                    disabled: _vm.disabled,
                    accept: _vm.fileAccept,
                    autofill: "new-password",
                    type: "file"
                  },
                  on: { change: _vm.handleFile }
                }),
                _vm._v(" "),
                _c(
                  "label",
                  { staticClass: "input-label", attrs: { for: _vm.id } },
                  [
                    _vm.fileName
                      ? _c(
                          "span",
                          [
                            _c("c-icon", {
                              attrs: { icon: "files-compare", width: "16" }
                            }),
                            _vm._v(" "),
                            _c("span", [_vm._v(_vm._s(_vm.fileName))])
                          ],
                          1
                        )
                      : _c(
                          "span",
                          { staticClass: "default" },
                          [
                            _c("c-icon", {
                              attrs: { icon: "file-plus", width: "16" }
                            }),
                            _vm._v(" "),
                            _c("span", [_vm._v(_vm._s(_vm.fileLabel))])
                          ],
                          1
                        )
                  ]
                )
              ]),
          _vm._v(" "),
          _vm.type === "color"
            ? _c("the-mask", {
                ref: "color",
                staticClass: "input -color",
                attrs: {
                  type: "text",
                  mask: "#FFFFFF",
                  masked: true,
                  tokens: _vm.hexTokens,
                  autofill: "new-password",
                  disabled: _vm.disabled,
                  required: _vm.required,
                  placeholder: _vm.placeholder,
                  autocomplete: "off"
                },
                on: {
                  focus: function($event) {
                    _vm.active = true
                  },
                  blur: function($event) {
                    _vm.active = false
                  },
                  change: _vm.handleChange,
                  keyup: [
                    _vm.handleKeyup,
                    function($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      ) {
                        return null
                      }
                      return _vm.handleEnter.apply(null, arguments)
                    },
                    function($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "esc", 27, $event.key, [
                          "Esc",
                          "Escape"
                        ])
                      ) {
                        return null
                      }
                      return _vm.handleEsc.apply(null, arguments)
                    }
                  ],
                  input: _vm.handleMaskInput
                },
                model: {
                  value: _vm.internalValue,
                  callback: function($$v) {
                    _vm.internalValue = $$v
                  },
                  expression: "internalValue"
                }
              })
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8d265d50", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8d265d50","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/convenia-components/CInput.vue
// module id = g2X9
// module chunks = 1624